<template>
  <section id="agency" ref="agencyContent">
    <PageTitle :title="$t('hospitality.settings.title')" :breadcrumbs="breadcrumbs"></PageTitle>
    
    <div class="wrapper wrapper-content animated fadeInRight">

      <Header></Header>

      <div class="row" v-if="selectedAgency">
        <div class="col">
          <Agency></Agency>
        </div>
      </div>
      
      <div class="row" v-if="selectedAgency && selectedAgency.options.isPaymentAdminAllowed">
        <div class="col">
          <MethodsOfPayment></MethodsOfPayment>
        </div>
      </div>

    </div>
  </section>
</template>


<script lang="ts">
import { Component } from '@fwk-node-modules/vue-property-decorator';
import { mixins } from '@fwk-node-modules/vue-class-component';
import GenericPage from '@fwk-client/components/mixins/GenericPage.vue';

import PageTitle from '@root/src/client/components/panels/PageTitle.vue';
import { enableIbox, disableIbox} from '@root/src/client/theme/inspinia-jquery'; 

import { useAgencyAdmin } from '../../composables/useAgencyAdmin';

import Header from '../panels/Header.vue';

import MethodsOfPayment from '../panels/settings/MethodsOfPayment.vue';
import Agency from '../panels/settings/Agency.vue';

@Component({
  components: {
    PageTitle,
    MethodsOfPayment,
    Header,
    Agency
  }
})
export default class Settings extends mixins(GenericPage) {

  setup(props:any, context:any) {
    const { agencies, selectedAgency } = useAgencyAdmin(props, context);
    return { agencies, selectedAgency }
  }

  get breadcrumbs() {
    return [{
      label: this.$t('home.dashboard')
    },
    {
      label: this.$t('hospitality.title')
    }]
  }

  mounted() {
    enableIbox(this.$refs.agencyContent as HTMLElement);
  }

  beforeDestroy() {
    disableIbox(this.$refs.agencyContent as HTMLElement);
  }

}
</script>